import { useTranslation } from 'react-i18next';
import ExclamationCircleIcon from '@/public/icons/approval/exclamation-circle.svg';
import {
  ReturnRequestNoticeBody,
  ReturnRequestNoticeHint,
  ReturnRequestNoticeIcon,
  ReturnRequestNoticeReason,
  ReturnRequestNoticeRoot,
  ReturnRequestNoticeTitle,
} from './styles';

/**
 * 반려요청 안내 — 기안자가 남긴 "반려해 달라"는 요청과 사유를 문서 상단에 알린다.
 *
 * 결재자 의견 영역이 아니라 상단에 따로 두는 이유는 두 가지다.
 * 첫째, 반려요청은 결재 결과가 아니라 부탁이라 결재 의견과 나란히 놓이면 결재가 된 것처럼 읽힌다.
 * 둘째, 노출 대상이 요청받은 현재 결재자와 기안자로 제한되는데, 모두에게 보이는 의견과 같은
 * 모양이면 공개된 내용으로 오해된다. 그래서 노출 대상 한 줄을 항상 함께 띄운다.
 *
 * 노출 여부 판정은 호출부(ApprovalView)가 하고, 본 컴포넌트는 표시만 한다.
 * 요청자는 항상 기안자이고 요청 시각은 서버에 보존되지 않아(PORTAL-14138) 이름·시각은 담지 않는다.
 */

type ReturnRequestNoticeProps = {
  /** 반려요청 사유. 비어 있으면 안내할 내용이 없어 렌더하지 않는다. */
  reason: string | null;
};

const ReturnRequestNotice = ({ reason }: ReturnRequestNoticeProps) => {
  const { t } = useTranslation();

  if (!reason || !reason.trim()) return null;

  return (
    <ReturnRequestNoticeRoot>
      <ReturnRequestNoticeIcon>
        <ExclamationCircleIcon />
      </ReturnRequestNoticeIcon>
      <ReturnRequestNoticeBody>
        <ReturnRequestNoticeTitle>
          {t('작성자가 반려를 요청했습니다')}
        </ReturnRequestNoticeTitle>
        <ReturnRequestNoticeReason>
          {t('사유')} · {reason}
        </ReturnRequestNoticeReason>
        <ReturnRequestNoticeHint>
          {t('현재 결재자와 작성자에게만 보입니다.')}
        </ReturnRequestNoticeHint>
      </ReturnRequestNoticeBody>
    </ReturnRequestNoticeRoot>
  );
};

export default ReturnRequestNotice;
